// src/firebase.ts
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCWBBu5dS-Siysojxk6CcdiuMHwtXqgJZ0",
  authDomain: "joinservicecall.firebaseapp.com",
  projectId: "joinservicecall",
  storageBucket: "joinservicecall.firebasestorage.app",
  messagingSenderId: "824753897805",
  appId: "1:824753897805:web:706ff3b06f8a02cecff704"
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

// Local cache to compare if token changed
let currentToken: string | null = null;

export const requestFirebaseNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn('Notification permission not granted');
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: 'BK6sm95UxmBmBwQZTITFU_8D_69HD-6c-9R9D6djc7epL1WquiUoYbSqZgotYjwOlEirnK8qJA4yr5x_sRyEhFo',
    });

    if (token && token !== currentToken) {
      currentToken = token;
      console.log('Firebase push token (new or refreshed):', token);
      // TODO: Send this token to your backend
    }

    return token;
  } catch (error) {
    console.error('Permission or token error', error);
    return null;
  }
};

export const onFirebaseMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
